import { Input } from "@mantine/core";
import { IconInfoSquare } from "@tabler/icons-react";
import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";

import { useDispatch } from "../../redux/hooks";
import { setIlModalData } from "../../redux/slices/generatorFeaturesSlice";
import { useInputProps } from "../hooks/useInputProps";
import useNMEAAutomated from "../hooks/useNMEAAutomated";

interface IIlInput {
  il?: string;
  value: any;
  id: string;
  orCode?: string;
  sectionIndex?: number;
  rowIndex?: number;
  required: boolean;
  tag?: string;
  isSingleRow?: boolean;
  name?: string;
  source?: "auto" | "manual";
  altInfoList?: boolean;
}

const IlInput = ({
  il = "",
  value,
  id,
  orCode,
  sectionIndex = -1,
  rowIndex = -1,
  required,
  tag,
  name,
  source,
  altInfoList: disabled,
}: IIlInput) => {
  const dispatch = useDispatch();
  const { ref: addToRefs, ...inputProps } = useInputProps(id, value, required);

  const { setValue } = useFormContext();
  const IlInputRef = useRef<HTMLInputElement | null>(null);

  const { handleNMEAChange } = useNMEAAutomated({
    id,
    source,
    sectionIndex,
    defaultValue: value,
    name,
  });

  const changeCellValue = (value: any) => {
    if (orCode === "or-code") {
      const firstNextSibling =
        IlInputRef?.current?.parentElement?.parentElement?.parentElement
          ?.nextElementSibling?.lastChild?.lastChild?.childNodes[0];

      if (firstNextSibling && firstNextSibling instanceof HTMLElement) {
        const firstCellId = firstNextSibling.getAttribute("name");
        if (firstCellId) setValue(firstCellId, value);
      }
    } else if (orCode === "or-number") {
      const firstLeftSibling =
        IlInputRef?.current?.parentElement?.parentElement?.parentElement
          ?.previousElementSibling?.lastChild?.lastChild?.childNodes[0];

      if (firstLeftSibling && firstLeftSibling instanceof HTMLElement) {
        const firstCellId = firstLeftSibling.getAttribute("name");
        if (firstCellId) setValue(firstCellId, value);
      }
    } else if (tag === "actcode") {
      const firstNextSibling =
        IlInputRef?.current?.parentElement?.parentElement?.parentElement
          ?.nextElementSibling;

      if (!firstNextSibling) return;
      const textarea = firstNextSibling.querySelector("textarea");
      if (!textarea) return;

      setValue(textarea.name, value);
    }
  };

  const handleOpen = () => {
    dispatch(
      setIlModalData({
        il,
        id: id.replace("overlay_", ""),
        orCode,
        changeCellValue,
        handleNMEAChange,
        sectionIndex,
        rowIndex,
        tag,
        disabled: false,
      }),
    );
  };

  return (
    <Input
      {...inputProps}
      readOnly={!disabled}
      name={id}
      miw={75}
      onClick={!disabled ? handleOpen : undefined}
      rightSection={
        <IconInfoSquare
          onClick={!disabled ? handleOpen : undefined}
          size="1rem"
          style={{
            opacity: 0.5,
            cursor: "pointer",
          }}
        />
      }
      ref={ref => {
        IlInputRef.current = ref;
        addToRefs(ref);
      }}
    />
  );
};
export default IlInput;
